<template>
  <div class="actions" :class="{ 'actions--align-right': alignRight }">
    <div v-if="!!$slots.composeActions" class="actions__compose">
      <slot name="composeActions" />
    </div>
    <slot v-if="!!$slots.publishActions" name="publishActions" />
  </div>
</template>

<script>
export default {
  name: "QaListItemActionsWrapper",
  props: {
    alignRight: {
      type: Boolean,
      default: false
    }
  }
};
</script>
<style lang="scss" scoped>
.actions {
  display: flex;

  &--align-right {
    justify-content: flex-end;
  }

  &__compose {
    width: 100%;
    display: flex;
    flex-direction: column;
  }
}
</style>
